<template>
    <div class="kgr-inputGroup">
        <div class="kgr-inputGroup__label">
            {{ $t('Zahlart') }}
        </div>
        <label
            v-for="option in options"
            :key="option.value"
            class="kgr-radio"
            :class="{ 'is-disabled' : option.disabled }"
        >
            <input
                type="radio"
                class="kgr-radio__control"
                :value="value"
                :disabled="option.disabled"
                :checked="option.value == value"
                @change="onInput(option.value)"
            />
            <span class="kgr-radio__label">{{ (option.label) }}</span>
        </label>
    </div>
</template>

<script>

export default {
    props: {
        options: {
            type: Array,
            required: true,
        },
        value: {
            type: String,
            required: false,
            default: 'cash',
        },
    },
    data() {
        return {
            method: this.value,
            radioPaymentMethod: 'RadioPaymentMethod',
        };
    },
    methods: {
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        },
    }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped></style>
